import { isEmpty } from 'lodash';
import { node } from 'prop-types';
import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { useFetch, useUser } from 'hooks';
import { routes } from 'router';
import { resetLeisurePurchaseStore, resetTravelPurchaseStore } from 'store';

const PurchaseProvider = ({ children }) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const previousLocation = useRef(location);
  const { currentUser } = useUser();
  const { call: deleteTravelCartCall } = useFetch({ withSetState: false });

  useEffect(() => {
    const resetStoreOnRouteChange = (route, resetAction) => {
      if (previousLocation.current.pathname.includes(route) && !location.pathname.includes(route)) {
        dispatch(resetAction());
        if (route === routes.travelPurchase.path) {
          deleteCart();
        }
      }
    };

    resetStoreOnRouteChange(routes.travelPurchase.path, resetTravelPurchaseStore);
    resetStoreOnRouteChange(routes.leisurePurchase.path, resetLeisurePurchaseStore);

    if (previousLocation.current.pathname !== location.pathname) {
      /* Scroll to top on route change */
      window.scrollTo({ top: 0, behavior: 'smooth' });
      /* Update previousLocation to the new route */
      previousLocation.current = location;
    }
  }, [location]);

  const deleteCart = () => {
    if (isEmpty(currentUser?.serialNumber)) return;

    deleteTravelCartCall({
      service: 'checkout',
      method: 'delete',
      path: `${currentUser.serialNumber}/cart/travel/`
    });
  };

  return <>{children}</>;
};

PurchaseProvider.propTypes = {
  children: node.isRequired
};

export default PurchaseProvider;
